import { Tooltip, useTranslate } from '@prenuvo/halo';

import { HeaderItem } from '../header-item.component';
import { ResponsiveList } from './responsive-list.component';
import { useResponsiveItems } from './use-responsive-items.hook';

export function ResponsiveItems() {
  const translate = useTranslate();
  const items = useResponsiveItems();

  return (
    <>
      <div className="hidden 2xl:flex">
        {items.map((item) => (
          <HeaderItem
            key={item.label}
            hideLabel={item.hideLabel}
            label={item.label}
            value={item.value}
          />
        ))}
      </div>

      <div
        aria-label={translate('FCT.ACCESSIBILITY.ARIA_LABELS.ADDITIONAL_PATIENT_INFORMATION')}
        className="flex cursor-pointer pl-2 2xl:hidden"
        data-testid="patient-info-tooltip"
      >
        <Tooltip content={<ResponsiveList />} side="bottom">
          <span className="rounded-md bg-stone-800 px-2 py-1">+{items.length}</span>
        </Tooltip>
      </div>
    </>
  );
}
